<template>
  <svg
    :width="width ? width : size"
    :height="height ? height : size"
    fill="none"
    :viewBox="viewbox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    viewbox: {
      type: String,
      default: '0 0 24 24',
    },
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    width: {
      type: [String],
      default: '',
    },
    height: {
      type: [String],
      default: '',
    },
  },

  computed: {
    pathSource() {
      // To support icons with multiple paths
      const path = this.icons[`${this.icon}-${this.type}`];
      if (path.constructor === Array) {
        return path;
      }
      return [path];
    },
  },
};
</script>
